/* unplugin-vue-components disabled */import { render } from "./VabThemeDrawer.vue?vue&type=template&id=1d7d42b4"
import script from "./VabThemeDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./VabThemeDrawer.vue?vue&type=script&setup=true&lang=js"

import "./VabThemeDrawer.vue?vue&type=style&index=0&id=1d7d42b4&lang=scss"
/* custom blocks */
import block0 from "./VabThemeDrawer.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "F:\\php-project\\admin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"library/components/VabTheme/components/VabThemeDrawer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d7d42b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d7d42b4', __exports__)) {
    api.reload('1d7d42b4', __exports__)
  }
  
  module.hot.accept("./VabThemeDrawer.vue?vue&type=template&id=1d7d42b4", () => {
    api.rerender('1d7d42b4', render)
  })

}


export default __exports__